<template>
    <div>
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="d-flex justify-content-between align-items-end">
                    <h1 class="mt-4">
                        {{$t('repair.title')}}
                        <small class="text-muted">ID#{{ repair.repair_id }}</small>
                    </h1>
                    <p class="text-right mt-4">
                        <b>{{$t('repair.lastupdate')}}:</b>
                        <slot
                            v-if="lastStatus.updated_at"
                        >{{ lastStatus.updated_at | moment("DD/MM/YYYY") }}</slot>
                        <br />
                        <slot
                            v-if="lastStatus.status_name && ['In Warranty', 'Partial Warranty'].includes(repair.warranty)"
                        >
                            <b>{{$t('repair.laststatus')}}:</b>
                            {{$t('status.repair[' + (lastStatus.status_id-1) + ']')}}
                        </slot>
                    </p>
                </div>
            </div>
        </div>
        <div class="row my-4" v-if="['In Warranty', 'Partial Warranty', 'Special Case'].includes(repair.warranty)">
            <ul class="progressbar">
                <li v-for="(stat, index) in status" :class="setProgress(stat)">                                        
                    <div v-if="['Special Case'].includes(repair.warranty) && stat.id == 7">
                        {{$t('status.repair[7]')}}
                    </div>
                    <div v-else>
                        {{$t('status.repair[' + (stat.id-1) + ']')}}
                    </div>
                    <br />
                    <small class="text-muted mt-2" v-html="getStatusUserAndDate(stat.status)"></small>
                </li>
            </ul>
            <br />
        </div>
        <div class="row my-4">
            <div class="col-md-9">
                <card
                    class="card"
                    v-if="['In Warranty', 'Partial Warranty'].includes(repair.warranty)"
                >
                    <div class="card-body text-center">
                        <h2 class="pt-0 mt-0">{{$t('repair.button.changestatus')}}</h2>
                        <h4 style="font-weight:200" class="mt-0">{{$t('status.repair[' + (lastStatus.status_id-1) + ']')}}</h4>
                        <button
                            class="btn btn-lg btn-primary px-4"
                            v-b-modal.formStatus
                            :disabled='isDisabled'
                        >{{$t('repair.button.changestatus')}}</button>
                    </div>
                </card>
                <card class="card">
                    <div class="card-body">
                        <h2 class="mt-0">{{$t('repair.titledetails')}}</h2>
                        <h4 class="text-primary">{{$t('repair.issuereported')}}</h4>
                        <hr />
                        <span v-if="repair.customer_issues_2">
                            <h5>{{$t('repair.errors')}}:</h5>
                            <ul>
                                <li
                                    v-for="(issues, index) in repair.customer_issues_2"
                                >{{ issues.name }}</li>
                            </ul>
                        </span>
                        <h5>{{$t('repair.description')}}:</h5>
                        {{ repair.issue_reported_customer }}
                        <br />

                        <h4 class="text-primary">{{$t('repair.technicalanalysis')}}</h4>
                        <hr />
                        {{ repair.technical_analysis }}
                        <br />

                        <h4 class="text-primary">{{$t('repair.serviceexecuted')}}</h4>
                        <hr />
                        {{ repair.service_executed }}
                        <br />
                        <div
                            v-if="repair.repairs_id_last_three_months && repair.repairs_id_last_three_months.length > 0"
                        >
                            <h4 class="text-primary">{{$t('repair.text.last90days')}}</h4>
                            <table class="table table-sm">
                                <thead>
                                    <tr class="bg-light">
                                        <th>{{$t('repair.repairid')}}</th>
                                        <th>{{$t('repair.createdat')}}</th>
                                        <th>{{$t('repair.lastupdate')}}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template
                                        v-for="old_repair in repair.repairs_id_last_three_months"
                                    >
                                        <tr>
                                            <td>
                                                <router-link
                                                    class="text-primary"
                                                    :to="{ name: 'repairs_edit', params: { id: old_repair.id } }"
                                                >{{ old_repair.repair_id }}</router-link>
                                            </td>
                                            <td>{{ old_repair.created_at.date | moment("DD/MM/YYYY") }}</td>
                                            <td>{{ old_repair.last_update.date | moment("DD/MM/YYYY") }}</td>
                                            <td>
                                                <router-link
                                                    class="btn btn-xs btn-primary ml-2"
                                                    :to="{ name: 'repairs_edit', params: { id: old_repair.id } }"
                                                >edit</router-link>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                        <br />

                        <br />
                        <div v-if="['In Warranty', 'Partial Warranty'].includes(repair.warranty)">
                            <h4 class="text-primary mt-0">{{$t('repair.statutshistory')}}</h4>
                            <hr />
                            <div role="tablist">
                                <slot v-for="(rep, i) in history_status">
                                    <div>
                                        <div role="tab" class="border-bottom">
                                            <a
                                                class="btn btn-sm btn-link d-block text-left p-0 m-0 rounded-0"
                                                href
                                                @click.prevent
                                                v-b-toggle="'st_'+i"
                                            >
                                                <i class="fas fa-plus-circle closed"></i>
                                                <i class="fas fa-minus-circle opened"></i>
                                                {{$t('status.repair[' + (rep.status_id-1) + ']') || ""}}
                                                <small v-if="rep.external_payment">{{$t('repair.text.external_payment')}}</small>
                                                <small
                                                    class="float-right text-primary"
                                                >
                                                    <i class="fas fa-clock mr-1"></i>
                                                    <b>{{ rep.created_at | moment("DD/MM/YYYY HH:mm:ss") }}</b>
                                                </small>
                                            </a>
                                        </div>

                                        <b-collapse
                                            :id="'st_'+i"
                                            accordion="status_history"
                                            role="tabpanel"
                                        >
                                            <div class="p-2 bg-light rounded">
                                                <div class="row my-1" v-if="rep.user_id">
                                                    <div class="col-lg-3 text-right">
                                                        <small class="text-primary">
                                                            <i class="fas fa-user mr-1"></i>
                                                            <b>{{$t('repair.user')}}:</b>
                                                        </small>
                                                    </div>
                                                    <div
                                                        class="col-lg-9"
                                                    >{{ getSafe(()=>rep.user_name)}}</div>
                                                </div>
                                                <div class="row my-1" v-if="rep.created_at">
                                                    <div class="col-lg-3 text-right">
                                                        <small class="text-primary text-truncate">
                                                            <i class="fas fa-clock mr-1"></i>
                                                            <b>{{$t('repair.updatedat')}}:</b>
                                                        </small>
                                                    </div>
                                                    <div
                                                        class="col-lg-9"
                                                    >{{ rep.created_at | moment("DD/MM/YYYY HH:MM:SS") }}</div>
                                                </div>
                                                <div class="row my-1" v-if="rep.notes">
                                                    <div class="col-lg-3 text-right">
                                                        <small class="text-primary">
                                                            <i class="fas fa-sticky-note mr-1"></i>
                                                            <b>{{$t('repair.notes')}}:</b>
                                                        </small>
                                                    </div>
                                                    <div
                                                        class="col-lg-9"
                                                    >{{ getSafe(()=>rep.notes)}}</div>
                                                </div>
                                            </div>
                                        </b-collapse>
                                    </div>
                                </slot>
                            </div>
                        </div>
                    </div>
                </card>
            </div>

            <!-- right column -->
            <div class="col-md-3">
                <shoppingCart
                    :showButtons="false"
                    :showOptions="false"
                    :cart_title="$t('request.partsrequest')"
                    v-if="['In Warranty', 'Partial Warranty'].includes(repair.warranty)"
                ></shoppingCart>
                <!-- marcel 2020-03-22: mostrar used parts -->
                <shoppingCart
                    :showButtons="false"
                    :showOptions="false"
                    :showUsedParts="true"
                    :cart_title="$t('request.partsused')"
                    v-if="['In Warranty', 'Partial Warranty'].includes(repair.warranty)"
                ></shoppingCart>
                <card class="card">
                    <div class="card-body">
                        <h4 class="card-title text-primary d-flex justify-content-between">
                            <span>{{ $t('repair.repairinformation')}}</span>
                            <p-button class="btn btn-primary btn-sm mb-3" v-b-modal.EditDetails>Edit</p-button>
                        </h4>
                        <hr />
                        <table>
                            <tr>
                                <td>
                                    <b>{{$t('repair.repairid')}}:</b>
                                </td>
                                <td>{{ repair.repair_id }}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>{{$t('repair.asfserviceid')}}:</b>
                                </td>
                                <td>{{ repair.service_number }}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>{{$t('repair.model')}}:</b>
                                </td>
                                <td>{{ repair.model_name }}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>{{$t('repair.serialn')}}:</b>
                                </td>
                                <td>{{ repair.serial_number }}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>{{$t('repair.warranty')}}:</b>
                                </td>
                                <td>{{ repair.warranty }}</td>
                            </tr>
                            <tr
                                v-if="['In Warranty', 'Partial Warranty'].includes(repair.warranty)"
                            >
                                <td>
                                    <b>{{$t('repair.invoicen')}} :</b>
                                </td>
                                <td>{{ repair.invoice_number }}</td>
                            </tr>
                            <tr
                                v-if="['In Warranty', 'Partial Warranty'].includes(repair.warranty)"
                            >
                                <td>
                                    <b>{{$t('repair.invoicedate')}} :</b>
                                </td>
                                <td>{{ this.$moment(repair.invoice_date).format("DD/MM/YYYY") }}</td>
                            </tr>
                            <tr
                                v-if="['In Warranty', 'Partial Warranty'].includes(repair.warranty) && invoice"
                            >
                                <td>
                                    <b>{{$t('repair.invoicefile')}}:</b>
                                </td>
                                <td v-if="getSafe(()=>invoice[0].name)">
                                    <a
                                        :href="getSafe(()=>invoice[0].src)"
                                        target="_blank"
                                        class="text-danger"
                                    >{{ getSafe(()=>invoice[0].name) }}</a>
                                    <a
                                        href="#"
                                        class="text-danger"
                                        alt="Download file"
                                        title="Download file"
                                        @click.prevent="downloadFile(getSafe(()=>invoice[0].src), getSafe(()=>invoice[0].name))"
                                    ><i class="fa fa-download"></i></a>
                                </td>
                            </tr>
                        </table>
                        <br />
                        <h4 class="card-title text-primary">{{$t('repair.customer')}}</h4>
                        <hr />
                        <table>
                            <tr>
                                <td>
                                    <b>{{$t('customer.name')}}:</b>
                                </td>
                                <td>{{ getSafe(()=>repair.customer.user.name) }}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>{{$t('customer.document')}}:</b>
                                </td>
                                <td>{{ getSafe(()=>repair.customer.document_type) }}: {{ getSafe(()=>repair.customer.document_number) }}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>{{$t('customer.email')}}:</b>
                                </td>
                                <td>{{ getSafe(()=>repair.customer.user.email) }}</td>
                            </tr>
                            <tr v-if="getSafe(()=>repair.customer.phones)">
                                <td class="align-top">
                                    <b>{{$t('customer.phones')}}:</b>
                                </td>
                                <td>
                                    <div v-for="(phone) in repair.customer.phones">{{ phone.phone }}</div>
                                </td>
                            </tr>
                            <tr v-if="getSafe(()=>repair.customer.addresses)">
                                <td class="align-top">
                                    <b>{{$t('customer.addresses')}}:</b>
                                </td>
                                <td>
                                    <div v-for="(address) in repair.customer.addresses">
                                        {{ address.address }} - {{ address.district }}
                                        <br />
                                        {{ address.city }}, {{ address.state }} - {{ address.country }}
                                    </div>
                                </td>
                            </tr>
                        </table>
                        <br />
                        <h4 class="card-title text-primary">{{$t('repair.asfdetails')}}</h4>
                        <hr />
                        <table>
                            <tr>
                                <td>
                                    <b>{{$t('asf.name')}}:</b>
                                </td>
                                <td>{{ repair_asf.name }}</td>
                            </tr>
                            <tr>
                                <td>
                                    <b>{{$t('asf.cnpj')}}:</b>
                                </td>
                                <td>{{ repair_asf.vat }}</td>
                            </tr>
                        </table>
                        <br />
                        <h4 class="card-title text-primary">{{$t('repair.productimages')}}</h4>
                        <hr />
                        <div class="row align-content-center">
                            <slot v-for="image, index in repair.uploads">
                                <div class="col-6 mb-4" v-if="image.type == 'product_images'">
                                    <img
                                        :src="getSafe(() => image.src)"
                                        class="img-fluid img-thumbnail"
                                        @click="showProdImgModal"
                                    />
                                </div>
                            </slot>
                        </div>
                    </div>
                </card>
            </div>
        </div>

        <!-- modals -->
        <b-modal
            id="shoppingCart"
            size="xl"
            hide-footer
            :title="$t('global.request_parts')"
            @hidden="shoppingCartHidden"
        >
            <parts-cart :showButtons="true" :showReqButton="false"></parts-cart>
        </b-modal>
        <b-modal
            id="formStatus"
            ref="formStatus"
            size="lg"
            class="card"
            hide-footer
            hide-header
            :title="$t('repair.button.changestatus')"
        >
            <h4 class="card-title pt-0 mt-0">{{$t('repair.button.changestatus')}}</h4>
            <hr />
            <form @submit.prevent id="statusEdit">
                <div class="row">
                    <div class="col-md-12">
                        <slot v-if="show.status">
                            <label for>{{$t('repair.status')}}</label>
                            <select class="form-control" v-model="objstatus" @change="selectStatus">
                                <option value>{{$t('repair.text.select')}}</option>
                                <option
                                    v-for="(stat, index) in status"
                                    :value="stat"
                                >{{ index+1 }}. {{$t('status.repair[' + index + ']')}}</option>
                            </select>
                        </slot>
                        <slot v-if="objstatus.id == 7">
                            <br />
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="external_payment" v-model="lastStatus.external_payment" name="external_payment">
                                <label class="form-check-label" for="external_payment">
                                    {{$t('repair.text.external_payment')}}
                                </label>
                            </div>
                        </slot>
                        <slot v-if="countCart == 0 && objstatus.id == 4">
                            <br />
                            <div
                                class="alert alert-danger"
                            >{{$t('repair.message.warnnopartselected')}}</div>
                        </slot>
                        <slot v-if="show.cart">
                            <br />
                            <p-button
                                class="btn btn-primary mb-3"
                                v-b-modal.shoppingCart
                            >{{$t('repair.button.selectparts')}}</p-button>
                            <shopping-cart
                                v-if="countCart > 0"
                                :showButtons="false"
                                :showOptions="false"
                                :showRequestButton="false"
                                :default_asf="repair.asf_id"
                            ></shopping-cart>
                        </slot>
                        <slot v-if="show.used_parts">
                            <br />
                            <shopping-cart
                                v-if="countCart > 0"
                                :showButtons="true"
                                :showOptions="true"
                                :showRequestButton="false"
                                :default_asf="repair.asf_id"
                                :cart_title="$t('part.partsused')"
                            ></shopping-cart>
                        </slot>
                    </div>
                </div>
                <br />
                <div class="row" v-if="show.notes">
                    <div class="col-md-12">
                        <label for="notes">{{$t('repair.notes')}}</label>
                        <textarea id="notes" class="form-control" v-model="form.notes"></textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <p-button type="primary" @click.native.prevent="save">{{$t('repair.button.save')}}</p-button>
                    </div>
                </div>
            </form>
        </b-modal>

        <b-modal ref="EditDetails" id="EditDetails" size="lg" hide-footer :title="$t('repair.titleedit')">
            <edit-repairs></edit-repairs>
        </b-modal>
        <b-modal size="lg" ref="prodImgModal" hide-footer hide-header>
            <img
                :src="prod_img_modal"
                alt
                class="img-fluid text-center"
                style="width:100% !important"
            />
        </b-modal>
    </div>
</template>
<script>
import PartsCart from "@/pages/parts/PartsCartRepairStatus.vue";
import shoppingCart from "@/pages/parts/ShoppingCart.vue";
import EditRepairs from "@/pages/repairs/EditRepairs.vue";
import {BCollapse} from "bootstrap-vue";
import {VBToggle} from "bootstrap-vue";

import { mapState } from "vuex";
export default {
  data() {
    return {
      prod_img_modal: null,
      objstatus: false,
      disabled: false,
      form: {
        repair_id: this.$route.params.id,
        status_id: "",
        status_name: "",
        status_order: "",
        notes: "",
        cart: "",
        asf_id: "",
        external_payment: ""
      },
      show: {
        status: true,
        notes: true,
        cart: false,
        used_parts: false
      }
    };
  },
  computed: {
    ...mapState("repairs", {
      repair: "repair",
      repair_asf: "repair_asf"
    }),
    status() {
    //   console.log(this.$store.getters["repairs/getStatus"]);
      return this.$store.getters["repairs/getStatus"];
    },
    history_status() {
      if (this.repair.status) return this.repair.status.reverse();
    },
    invoice() {
      if (!this.repair.uploads) return false;
      return this.repair.uploads.filter(item => item.type == "invoice_file");
    },
    isDisabled: function(){
    	return this.disabled;
    },
    lastStatus() {
      if (!this.history_status) {
        return { updated_at: "" };
      } else {
        return this.history_status[0];
      }
    },
    countCart() {
      return this.$store.getters["cart/count"];
    },
    pageIs() {
      if (window.location.pathname.includes("parts")) return "requests";
      if (window.location.pathname.includes("repair")) return "repair_status";
    },
    console: () => console
    // asf() {
    //   return this.store.getters["auth/getAsf"];
    // }
  },
  methods: {
    getStatusUserAndDate(status) {
      if (status.length > 0) {
        let last = status[status.length - 1];
        return (
          "<div class='my-1'>" +
          last.user_name +
          "</div><div class='my-1'>" +
          this.$moment(last.created_at).format("DD.MM.YYYY HH:mm:ss") +
          "</div>"
        );
      }
    },
    getSafe(fn, defaultVal) {
      try {
        return fn();
      } catch (e) {
        return defaultVal;
      }
    },
    downloadFile(url, filename) {
      this.$http({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      })
      .then(response => {
        const url2 = window.URL.createObjectURL(new Blob([response.data], {type:response.headers['content-type']}));
        const link = document.createElement('a');
        link.href = url2;
        link.setAttribute('download', filename);
            //document.body.appendChild(link);
        link.click();
      })
      .catch(error => {
        console.log('error occured: ' + error.message)
      });
    },
    showProdImgModal(e) {
      this.prod_img_modal = e.target.src;
      this.$refs.prodImgModal.show();
    },
    selectStatus: function(e) {
      this.form.status_id = this.objstatus.id;
      this.form.status_name = this.objstatus.name;
      this.form.status_order = this.objstatus.order;

      let fields = this.objstatus.fields || ["status", "notes", "external_payment"];
      let show = this.show;
      Object.keys(show).forEach(function(key, index) {
        if (fields && fields.includes(key)) {
          show[key] = true;
        } else {
          show[key] = false;
        }
      });
      this.show = show;
    },
    hideRepairEdit() {
      this.$refs.formStatus.show();
    },
    shoppingCartHidden(evt) {
      this.$refs.formStatus.show();
    },
    setProgress(item) {
      if (item.name == this.lastStatus.status_name) return "active";
      if (item.order < this.lastStatus.status_order) return "done";
    },
    showEditStatus() {
      return true;
    },
    save() {
        //console.log(this.form);
      this.disabled = true;
      this.form.cart = this.$store.getters["cart/inCart"];
      if (!this.form.asf_id) this.form.asf_id = this.repair.asf_id;
      this.$store
        .dispatch("repairs/updateStatus", this.form)
        .then(result => {
          this.$refs.formStatus.hide();
          this.form.notes = "";
          this.$notify({
            type: "success",
            message: this.$t('repair.message.successupdatestatus')
          });
          //console.log("result.data.requests");
          //console.log(result.data.requests);
          if (result.data.requests) {
            this.$store.commit(
              "cart/setCart",
              result.data.requests[result.data.requests.length - 1].items
            );
          }
          this.$store.dispatch("repairs/get", this.$route.params.id);
          this.$store.dispatch("repairs/getStatus", this.$route.params.id);
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
        this.disabled = false;
    }
  },
  created() {
    this.$store.dispatch("repairs/get", this.$route.params.id);
    this.$store.dispatch("repairs/getStatus", this.$route.params.id);
    this.$store.dispatch("cart/getAllParts", this.pageIs);
    this.$store.dispatch("cart/getAllCategories");
  },
  components: {
    PartsCart,
    shoppingCart,
    EditRepairs,
    "b-collapse": BCollapse
  },
  directives: {
    "b-toggle": VBToggle
  }
};
</script>
<style>
.collapsed > i.opened,
:not(.collapsed) > i.closed {
  display: none;
}
</style>
